<template>
  <base-nav
    :class="{ 'bg-success navbar-dark': type === 'default' }"
    class="navbar-top border-bottom navbar-expand"
    container-classes="container-fluid"
  >
    <!-- Search form -->
    <form
      id="navbar-search-main"
      :class="{ 'navbar-search-light': type === 'default', 'navbar-search-dark': type === 'light' }"
      class="navbar-search form-inline mr-sm-3 d-none"
    >
      <div class="form-group mb-0 d-none">
        <div class="input-group input-group-alternative input-group-merge">
          <div class="input-group-prepend">
            <span class="input-group-text"><i class="fas fa-search"></i></span>
          </div>
          <input class="form-control" placeholder="Search" type="text" />
        </div>
      </div>
      <button
        aria-label="Close"
        class="close"
        data-action="search-close"
        data-target="#navbar-search-main"
        type="button"
      >
        <span aria-hidden="true">×</span>
      </button>
    </form>

    <!-- Back action-->
    <form
      :class="{ 'navbar-search-light': type === 'default', 'navbar-search-dark': type === 'light' }"
      class="form-inline mr-sm-3 d-none d-sm-inline-block"
    >
      <button
        class="btn base-button btn-icon-only rounded-circle btn-neutral button-back"
        type="button"
        @click="goBack"
      >
        <i class="fas fa-arrow-left"></i>
      </button>
    </form>

    <!-- Navbar links -->
    <ul class="navbar-nav align-items-center ml-md-auto">
      <li cy-id="open-sidebar" class="nav-item d-xl-none">
        <!-- Sidenav toggler -->
        <div
          :class="{
            active: $sidebar.showSidebar,
            'sidenav-toggler-dark': type === 'default',
            'sidenav-toggler-light': type === 'light',
          }"
          class="pr-3 sidenav-toggler"
          @click="toggleSidebar"
        >
          <div class="sidenav-toggler-inner">
            <i class="sidenav-toggler-line"></i>
            <i class="sidenav-toggler-line"></i>
            <i class="sidenav-toggler-line"></i>
          </div>
        </div>
      </li>
      <li class="nav-item d-sm-none">
        <button
          class="btn base-button btn-icon-only rounded-circle btn-neutral button-back"
          type="button"
          @click="goBack"
        >
          <i class="fas fa-arrow-left"></i>
        </button>
      </li>

      <base-dropdown
        class="nav-item d-none"
        icon="ni ni-bell-55"
        menu-classes="dropdown-menu-xl dropdown-menu-right py-0 overflow-hidden"
        tag="li"
        title-classes="nav-link"
        title-tag="a"
      >
        <template>
          <!-- Dropdown header -->
          <div class="px-3 py-3">
            <h6 class="text-sm text-muted m-0">You have <strong class="text-primary">13</strong> notifications.</h6>
          </div>
          <!-- List group -->
          <div class="list-group list-group-flush">
            <a class="list-group-item list-group-item-action" href="#!">
              <div class="row align-items-center">
                <div class="col-auto">
                  <!-- Avatar -->
                  <img alt="Image placeholder" class="avatar rounded-circle" src="img/theme/team-1.jpg" />
                </div>
                <div class="col ml--2">
                  <div class="d-flex justify-content-between align-items-center">
                    <div>
                      <h4 class="mb-0 text-sm">John Snow</h4>
                    </div>
                    <div class="text-right text-muted">
                      <small>2 hrs ago</small>
                    </div>
                  </div>
                  <p class="text-sm mb-0">Let's meet at Starbucks at 11:30. Wdyt?</p>
                </div>
              </div>
            </a>
            <a class="list-group-item list-group-item-action" href="#!">
              <div class="row align-items-center">
                <div class="col-auto">
                  <!-- Avatar -->
                  <img alt="Image placeholder" class="avatar rounded-circle" src="img/theme/team-2.jpg" />
                </div>
                <div class="col ml--2">
                  <div class="d-flex justify-content-between align-items-center">
                    <div>
                      <h4 class="mb-0 text-sm">John Snow</h4>
                    </div>
                    <div class="text-right text-muted">
                      <small>3 hrs ago</small>
                    </div>
                  </div>
                  <p class="text-sm mb-0">A new issue has been reported for Argon.</p>
                </div>
              </div>
            </a>
            <a class="list-group-item list-group-item-action" href="#!">
              <div class="row align-items-center">
                <div class="col-auto">
                  <!-- Avatar -->
                  <img alt="Image placeholder" class="avatar rounded-circle" src="img/theme/team-3.jpg" />
                </div>
                <div class="col ml--2">
                  <div class="d-flex justify-content-between align-items-center">
                    <div>
                      <h4 class="mb-0 text-sm">John Snow</h4>
                    </div>
                    <div class="text-right text-muted">
                      <small>5 hrs ago</small>
                    </div>
                  </div>
                  <p class="text-sm mb-0">Your posts have been liked a lot.</p>
                </div>
              </div>
            </a>
            <a class="list-group-item list-group-item-action" href="#!">
              <div class="row align-items-center">
                <div class="col-auto">
                  <!-- Avatar -->
                  <img alt="Image placeholder" class="avatar rounded-circle" src="img/theme/team-4.jpg" />
                </div>
                <div class="col ml--2">
                  <div class="d-flex justify-content-between align-items-center">
                    <div>
                      <h4 class="mb-0 text-sm">John Snow</h4>
                    </div>
                    <div class="text-right text-muted">
                      <small>2 hrs ago</small>
                    </div>
                  </div>
                  <p class="text-sm mb-0">Let's meet at Starbucks at 11:30. Wdyt?</p>
                </div>
              </div>
            </a>
            <a class="list-group-item list-group-item-action" href="#!">
              <div class="row align-items-center">
                <div class="col-auto">
                  <!-- Avatar -->
                  <img alt="Image placeholder" class="avatar rounded-circle" src="img/theme/team-5.jpg" />
                </div>
                <div class="col ml--2">
                  <div class="d-flex justify-content-between align-items-center">
                    <div>
                      <h4 class="mb-0 text-sm">John Snow</h4>
                    </div>
                    <div class="text-right text-muted">
                      <small>3 hrs ago</small>
                    </div>
                  </div>
                  <p class="text-sm mb-0">A new issue has been reported for Argon.</p>
                </div>
              </div>
            </a>
          </div>
          <!-- View all -->
          <a class="dropdown-item text-center text-primary font-weight-bold py-3" href="#!">View all</a>
        </template>
      </base-dropdown>
      <base-dropdown
        class="nav-item d-none"
        icon="ni ni-ungroup"
        menu-classes="dropdown-menu-lg dropdown-menu-dark bg-default dropdown-menu-right"
        tag="li"
        title-classes="nav-link"
        title-tag="a"
      >
        <template>
          <div class="row shortcuts px-4">
            <a class="col-4 shortcut-item" href="#!">
              <span class="shortcut-media avatar rounded-circle bg-gradient-red">
                <i class="ni ni-calendar-grid-58"></i>
              </span>
              <small>Calendar</small>
            </a>
            <a class="col-4 shortcut-item" href="#!">
              <span class="shortcut-media avatar rounded-circle bg-gradient-orange">
                <i class="ni ni-email-83"></i>
              </span>
              <small>Email</small>
            </a>
            <a class="col-4 shortcut-item" href="#!">
              <span class="shortcut-media avatar rounded-circle bg-gradient-info">
                <i class="ni ni-credit-card"></i>
              </span>
              <small>Payments</small>
            </a>
            <a class="col-4 shortcut-item" href="#!">
              <span class="shortcut-media avatar rounded-circle bg-gradient-green">
                <i class="ni ni-books"></i>
              </span>
              <small>Reports</small>
            </a>
            <a class="col-4 shortcut-item" href="#!">
              <span class="shortcut-media avatar rounded-circle bg-gradient-purple">
                <i class="ni ni-pin-3"></i>
              </span>
              <small>Maps</small>
            </a>
            <a class="col-4 shortcut-item" href="#!">
              <span class="shortcut-media avatar rounded-circle bg-gradient-yellow">
                <i class="ni ni-basket"></i>
              </span>
              <small>Shop</small>
            </a>
          </div>
        </template>
      </base-dropdown>
    </ul>

    <ul class="navbar-nav align-items-center ml-auto">
      <li class="nav-item">
        <div v-if="currentCampaignName !== null">
          <span class="h3 font-weight-bold text-white mx-3"> Campaña Actual: {{ currentCampaignName }} </span>
        </div>
      </li>

      <li class="nav-item">
        <dollar-lastest-quotation />
      </li>
    </ul>

    <ul class="navbar-nav align-items-center ml-auto ml-md-0">
      <base-dropdown cy-id="user" class="nav-item" menu-on-right tag="li" title-classes="nav-link pr-0" title-tag="a">
        <a slot="title-container" class="nav-link pr-0" href="#" @click.prevent>
          <div v-if="$auth.check()" class="media align-items-center">
            <span class="avatar avatar-sm rounded-circle bg-blue">
              <span class="font-weight-bolder text-uppercase">
                {{
                  $auth
                    .user()
                    .data.name.split(/\s/)
                    .slice(0, 2)
                    .map((i) => i.split('').shift())
                    .join('')
                }}
              </span>
            </span>
            <div class="media-body ml-2 d-none d-lg-block">
              <span class="mb-0 text-sm font-weight-bold text-uppercase">{{ $auth.user().data.name }}</span>
            </div>
          </div>
        </a>

        <template>
          <div class="dropdown-header noti-title">
            <h6 class="text-overflow m-0">Bienvenido!</h6>
          </div>

          <a class="dropdown-item d-none" href="#!">
            <i class="fas fa-user-cog"></i>
            <span>Mi perfil</span>
          </a>
          <a class="dropdown-item d-none" href="#!">
            <i class="fas fa-cog"></i>
            <span>Configuración</span>
          </a>
          <a class="dropdown-item d-none" href="#!">
            <i class="ni ni-calendar-grid-58"></i>
            <span>Actividad</span>
          </a>
          <a class="dropdown-item d-none" href="#!">
            <i class="far fa-life-ring"></i>
            <span>Ayuda</span>
          </a>
          <div class="dropdown-divider"></div>
          <a v-if="$auth.check()" cy-id="logout" class="dropdown-item" @click="$auth.logout({ redirect: '/login' })">
            <i class="fas fa-sign-out-alt"></i>
            <span>Cerrar Sesión</span>
          </a>
        </template>
      </base-dropdown>
    </ul>
  </base-nav>
</template>

<script>
import { mapGetters } from 'vuex';

import { BaseNav } from '@/components';
import DollarLastestQuotation from '@/views/Layout/DollarLastestQuotation.vue';

export default {
  components: {
    BaseNav,
    DollarLastestQuotation,
  },

  props: {
    type: {
      type: String,
      default: 'default', // default|light
      description: 'Look of the dashboard navbar. Default (Green) or light (gray)',
    },
  },

  data() {
    return {
      activeNotifications: false,
      showMenu: false,
      searchModalVisible: false,
      searchQuery: '',
    };
  },

  computed: {
    ...mapGetters('navigation', ['currentCampaignName']),

    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    },
  },

  methods: {
    goBack() {
      this.$router.go(-1);
    },

    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },

    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },

    closeDropDown() {
      this.activeNotifications = false;
    },

    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },

    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
  },
};
</script>

<style scoped>
.button-back {
  color: #2dce89;
}

.button-back:hover {
  color: #2d2d2d;
}
</style>
